exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header{\n\n  margin-top: 15%;\n   margin-left: 35%;\n   margin-bottom: 0px;\n   width: 30%;\n\n}\n.panel {\n  padding: 20px;\n  \n  margin-left: 35%;\n  width: 30%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/main/resources/js/components/LogInMail.css
// module id = 130
// module chunks = 0